import TotalCostConfirmation from './TotalCostConfirmation.component';
export default TotalCostConfirmation;